// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"DiagramBoxSkeletonLoader_skeletonLoader__tz24j"};